import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5eedea98 = () => interopDefault(import('../../../pages/careersitem.vue' /* webpackChunkName: "pages/careersitem" */))
const _79998220 = () => interopDefault(import('../../../pages/squircle.vue' /* webpackChunkName: "pages/squircle" */))
const _0a31df18 = () => interopDefault(import('../../../pages/blog/_blog.vue' /* webpackChunkName: "pages/blog/_blog" */))
const _472b8f64 = () => interopDefault(import('../../../pages/_tower.vue' /* webpackChunkName: "pages/_tower" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/careersitem",
    component: _5eedea98,
    name: "careersitem___en"
  }, {
    path: "/squircle",
    component: _79998220,
    name: "squircle___en"
  }, {
    path: "/jp/careersitem",
    component: _5eedea98,
    name: "careersitem___jp"
  }, {
    path: "/jp/squircle",
    component: _79998220,
    name: "squircle___jp"
  }, {
    path: "/jp/blog/:blog",
    component: _0a31df18,
    name: "blog-blog___jp"
  }, {
    path: "/jp/:tower*",
    component: _472b8f64,
    name: "tower___jp"
  }, {
    path: "/blog/:blog",
    component: _0a31df18,
    name: "blog-blog___en"
  }, {
    path: "/:tower*",
    component: _472b8f64,
    name: "tower___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
